/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitCell = createReactComponent("circuit-cell", "IconCircuitCell", [
  ["path", { d: "M2 12h8", key: "svg-0" }],
  ["path", { d: "M14 12h8", key: "svg-1" }],
  ["path", { d: "M10 5v14", key: "svg-2" }],
  ["path", { d: "M14 9v6", key: "svg-3" }]
]);

export { IconCircuitCell as default };
//# sourceMappingURL=IconCircuitCell.js.map
